import { Pipe, PipeTransform } from '@angular/core';
import {ETargetAccountType} from "../enums/ETargetAccountType";

@Pipe({
  name: 'filterTransferCard'
})
export class FilterTransferCardPipe implements PipeTransform {

  transform(transferType: string): string {
    switch (transferType) {
      case ETargetAccountType.INTERNAL_CARD:
        return $localize`:@@transferInternalCard:Tarjeta`;
      case ETargetAccountType.INTERNATIONAL:
        return $localize`:@@transferInternalCard:Tarjeta`;
      default:
        return status.toString();
    }
  }

}
